import moment from 'moment';

export function GetMomentOfDate(date: Date | string) {
  return moment(date);
}
